import Vue from 'vue';

const chunk = (myArray, chunk_size) => {
    let results = [];

    while (myArray.length) {
        results.push(myArray.splice(0, chunk_size).join(' '))
    }

    return results;
}


Vue.filter('wrapWords', function (string, length) {
  let parts = chunk(string.split(' '), length);
  let html = '<span class="word-wrap">' + parts.join('</span> <span class="word-wrap">') + '</span>';
  return html;
})



// WEBPACK FOOTER //
// ./src/filters/WrapWords.js